import BookItem from "../common/bookItem";
import { mouseEvent } from "../common/mouse_event";
export default class VisibleSwitchListChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;

        mouseEvent.add_mouse_event(this);
        
        this.target.gotoAndStop(0);
    }
    // 沒用了
    init() {

        if (this.connectNumber.length > 0) {
            this.target.visible = false;
        }
    }
    trigger() {
        // console.log('do something');
    }
}